import { supabase } from 'common/src/supabase';
import { Tasker } from 'common/src/utils/types';

export const sendTaskerStatusEmail = async (
  tasker: Tasker,
  isApproved: boolean
) => {
  const subject = isApproved
    ? 'Tu solicitud para ser Tasker ha sido aprobada'
    : 'Actualización sobre tu solicitud para ser Tasker';

  const content = `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
    </head>
    <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
      <div style="background-color: #a834a4; color: white; padding: 20px; text-align: center; border-radius: 10px 10px 0 0;">
        <h1 style="margin: 0;">${subject}</h1>
      </div>
      <div style="background-color: #f9f9f9; padding: 20px; border-radius: 0 0 10px 10px;">
        <p>Hola ${tasker.name},</p>

        ${
          isApproved
            ? `<p>¡Estamos encantados de informarte que tu solicitud para ser Tasker ha sido aprobada! ¡Bienvenido oficialmente al equipo de TaskyApp!</p>
             <p>Aquí tienes toda la información que necesitas para comenzar tu emocionante viaje como Tasker:</p>
             <ul>
               <li>Recibirás notificaciones por SMS y correo electrónico cuando haya nuevas tareas disponibles para ti. También te avisaremos si te asignan una tarea.</li>
               <li>Puedes acceder a tu panel de control de Tasker en <a href="https://taskers.taskyapp.cl">taskers.taskyapp.cl</a>. Allí podrás ver y postular a tareas.</li>
               <li>Te enviaremos por correo electrónico toda la información necesaria para realizar cada tarea que te sea asignada.</li>
               <li>Si necesitas ayuda o tienes alguna pregunta, no dudes en contactarnos a través de WhatsApp. Estamos aquí para apoyarte en todo momento.</li>
             </ul>
             <p>Estamos emocionados de tenerte a bordo y confiamos en que harás un trabajo excepcional. ¡Te deseamos mucho éxito en tu nueva aventura como Tasker!</p>`
            : `<p>Gracias por tu interés en ser parte de nuestro equipo de Taskers. Después de revisar cuidadosamente tu solicitud, lamentamos informarte que no podemos aprobarla en este momento.</p>
             <p>Te animamos a que sigas mejorando tus habilidades y consideres aplicar nuevamente en el futuro.</p>`
        }

        <p>Si tienes alguna pregunta adicional, no dudes en contactarnos.</p>

        <p>¡Saludos cordiales y mucho éxito!<br>El equipo de TaskyApp</p>
      </div>
    </body>
    </html>
  `;

  try {
    const { data, error } = await supabase.functions.invoke('sendEmail', {
      body: JSON.stringify({
        email: tasker.email,
        subject: subject,
        content: content,
      }),
    });

    if (error) {
      console.error('Error sending tasker status email:', error);
      throw error;
    }

    if (data && data.message === 'Email sent successfully') {
      console.log('Tasker status email sent successfully');
      return data;
    } else {
      console.error('Unexpected response format:', data);
      throw new Error('Unexpected response format');
    }
  } catch (error) {
    console.error('Error sending tasker status email:', error);
    throw error;
  }
};
